export const quizData = [
  {
    question: "Hallo, ich bin Maria. Und wie _______ du? David",
    incorrect_answers: ["machst", "bist", "bin"],
    correct_answer: "heisst",
  },
  {
    question: "Und was bist du von Beruf? Ich _______ Pilot.",
    incorrect_answers: ["habe", "arbeite", "gehe"],
    correct_answer: "bin",
  },
  {
    question:
      "Entschuldigen Sie, wo _______ ich hier Brot? Im nächsten Gang links.",
    incorrect_answers: ["suche", "esse", "nehme"],
    correct_answer: "finde",
  },
  {
    question: "Ich hätte gerne _______ Saft. Orangensaft oder Apfelsaft?",
    incorrect_answers: ["ein Pfund", "einen Teller", "ein Kilo"],
    correct_answer: "ein Glas",
  },
  {
    question: "Wie lange wohnen Sie _______ hier? Über sieben Jahre.",
    incorrect_answers: ["erst", "über", "fast"],
    correct_answer: "schon",
  },
  {
    question: "Ich bin nicht verheiratet. Und du? _______.",
    incorrect_answers: ["Ja, bitte", "Ich nicht", "Ich auch"],
    correct_answer: "Ich auch nicht",
  },
  {
    question:
      "Wissen Sie eigentlich, dass Frau Meier heute Geburtstag hat? Ja, klar! _______ zum Geburtstag, Frau Meier!",
    incorrect_answers: ["Guten", "Gute", "Gutes"],
    correct_answer: "Alles Gute",
  },
  {
    question:
      "Papa, ich möchte noch nicht schlafen. Darf ich noch ein bisschen lesen? Nein, es ist schon spät, ich mache das Licht jetzt _______.",
    incorrect_answers: ["an", "zu", "auf"],
    correct_answer: "aus",
  },
  {
    question: "Ich muss meine Oma anrufen. Kannst du mir dein Handy _______?",
    incorrect_answers: ["brauchen", "kaufen", "abholen"],
    correct_answer: "geben",
  },
  {
    question:
      "Entschuldigung, wie _______ wir zum Museum? Das ist weit. Fahren Sie besser mit dem Bus.",
    incorrect_answers: ["suchen", "möchten", "wollen"],
    correct_answer: "kommen",
  },
  {
    question:
      "Guten Tag, Herr Müller. Wie geht es Ihnen? Danke, gut. Und _______?",
    incorrect_answers: ["dir", "Sie", "du"],
    correct_answer: "Ihnen",
  },
  {
    question:
      "Sprechen Sie Italienisch? Nein, ich komme aus Kolumbien. Ich spreche _______ und ein bisschen Deutsch.",
    incorrect_answers: ["in Spanisch", "auf Spanisch", "Spanien"],
    correct_answer: "Spanisch",
  },
  {
    question: "_______ fliegt Peter? _______ Berlin.",
    incorrect_answers: ["Woher ... In", "Wie … Auf", "Wo ... Aus"],
    correct_answer: "Wohin ... Nach",
  },
  {
    question: "Petra wohnt in Winterthur. Und sie _______ am Flughafen.",
    incorrect_answers: ["Arbeit", "arbeiten", "arbeitest"],
    correct_answer: "arbeitet",
  },
  {
    question: "Was _______ du am liebsten? Hamburger.",
    incorrect_answers: ["esse", "ist", "esst"],
    correct_answer: "isst",
  },
  {
    question:
      "Guten Abend. Was darf’s sein? Wir nehmen _______ Kaffee und _______ Mineralwasser.",
    incorrect_answers: ["eine ... eine", "die ... die", "der ... das"],
    correct_answer: "einen ... ein",
  },
  {
    question:
      "Schau mal, der Stuhl ist doch elegant. Ich weiss nicht. _______ finde ich nicht so schön.",
    incorrect_answers: ["Ihn", "Den", "Die"],
    correct_answer: "Das",
  },
  {
    question:
      "Guten Tag. Ich suche einen Mantel. _______ finden Sie in der Herrenabteilung.",
    incorrect_answers: ["Mantels", "Mänteln", "Mantel"],
    correct_answer: "Mäntel",
  },
  {
    question:
      "Papa, kaufst du _______ Schokolade? Nein, heute bekommst du keine Schokolade.",
    incorrect_answers: ["ihr", "euch", "dir"],
    correct_answer: "mir",
  },
  {
    question: "Kann ich _______ helfen? Ja, gerne. Wo gibt es denn hier Käse?",
    incorrect_answers: ["dich", "Sie", "ihr"],
    correct_answer: "Ihnen",
  },
  {
    question: "Gehst du mit mir morgen _______ Theater? Ja, gerne.",
    incorrect_answers: ["zur", "im", "beim"],
    correct_answer: "ins",
  },
  {
    question: "Die Lektion beginnt um 17.40 Uhr, oder? Ja genau, um _______.",
    incorrect_answers: [
      "zehn nach halb sechs",
      "Viertel vor sechs",
      "vierzig nach fünf",
    ],
    correct_answer: "zwanzig vor sechs",
  },
  {
    question:
      "Mama, _______ ich mit Sandra im Hof spielen gehen? Nein, du _______ noch Hausaufgaben machen.",
    incorrect_answers: [
      "muss ... darfst",
      "dürfen ... sollst",
      "kann ... müsst",
    ],
    correct_answer: "darf ... musst",
  },
  {
    question:
      "Ich brauche dringend einen Termin. Geht es _______ Mittwoch _______ 10 Uhr?",
    incorrect_answers: ["um ... am", "von ... bis", "bis ... von"],
    correct_answer: "am ... um",
  },
  {
    question:
      "Arbeiten Ihre Eltern noch? Ja, _______ Mutter arbeitet in einem Hotel und _______ Vater ist Taxifahrer in Zürich.",
    incorrect_answers: ["seine ... ihr", "mein ... meine", "unser ... unsere"],
    correct_answer: "meine ... mein",
  },
  {
    question: "Sag mal, wo ist denn die Katze? Die _______ Bett und schläft.",
    incorrect_answers: ["liegt auf den", "legt auf dem", "legt auf den"],
    correct_answer: "liegt auf dem",
  },
  {
    question:
      "Warum _______ du letzten Samstag nicht auf Veras Party? Ich _______ bis halb elf im Büro.",
    incorrect_answers: ["bist ... bin", "waren ... bin", "wart ... war"],
    correct_answer: "warst ... war",
  },
  {
    question:
      "Was hast du gestern in Bern _______ ? Ich _______ ein Vorstellungsgespräch.",
    incorrect_answers: [
      "machst ... gehabt",
      "macht ... habe",
      "machen ... nehme",
    ],
    correct_answer: "gemacht ... hatte",
  },
  {
    question: "Wie war es in Paris? Super, ich ______ drei Wochen dort ______.",
    incorrect_answers: [
      "bin ... geblieben",
      "hatte ... geblieben",
      "werde ... geblieben",
    ],
    correct_answer: "habe ... geblieben ",
  },
  {
    question:
      "Wie gefällt Ihnen der Zürichsee? Keine Ahnung. Ich habe _______ noch nie gesehen.",
    incorrect_answers: ["ein", "er", "es"],
    correct_answer: "ihn",
  },
  {
    question:
      "Lass uns im Urlaub nach Südspanien fliegen. Ich möchte endlich wieder einmal richtig braun sein. Also ich weiss nicht. Ich möchte nicht den ganzen Tag in der _______ liegen.",
    incorrect_answers: ["Hafen", "Land", "Sonne"],
    correct_answer: "Strand",
  },
  {
    question: "Guten Appetit! _______",
    incorrect_answers: ["Ja, natürlich.", "Ich auch.", "Na und?"],
    correct_answer: "Danke, gleichfalls.",
  },
  {
    question:
      "Wir möchten eine Lastminute-Reise machen. Aber sie darf nicht zu viel kosten. Schauen Sie doch mal im Internet. Da gibt es oft _______ Angebote.",
    incorrect_answers: ["grosse", "hilfsbereite", "teure"],
    correct_answer: "günstige",
  },
  {
    question:
      "Müsst ihr keine Hausaufgaben machen? _______, aber wir haben heute einfach keine Lust!",
    incorrect_answers: ["Danke", "Nein", "Bitte"],
    correct_answer: "Eigentlich schon",
  },
  {
    question:
      "Haben Sie noch ein Zimmer für zwei Personen frei? Sie haben Glück! Wir haben noch ein _______.",
    incorrect_answers: ["Übernachtung", "Einzelzimmer", "Unterkunft"],
    correct_answer: "Doppelzimmer",
  },
  {
    question:
      "Guten Tag, Herr Doktor. Guten Tag, Herr Müller. Was _______ Ihnen denn?",
    incorrect_answers: ["weh tun", "geht", "haben"],
    correct_answer: "fehlt",
  },
  {
    question:
      "So ein Mist, jetzt ist mein Motorrad schon wieder _______. Du kannst mein Auto nehmen.",
    incorrect_answers: [
      "fertig gegangen",
      "aus dem Service gegangen",
      "gegangen",
    ],
    correct_answer: "kaputt gegangen",
  },
  {
    question:
      "Soll ich diese Jacke kaufen? Ja, unbedingt. Sie ______ dir ausgezeichnet.",
    incorrect_answers: ["wirkt", "trägt", "gefällt"],
    correct_answer: "steht",
  },
  {
    question:
      "Haben Sie schon gehört? Frau Schmid hat einen neuen Freund. Das ist doch nichts _______. Das weiss ich schon lange.",
    incorrect_answers: ["wichtig", "neu", "Wichtiges"],
    correct_answer: "Neues",
  },
  {
    question:
      "Wie viele Zimmer hat deine neue Wohnung? Drei. Zwei Schlafzimmer und das _______.",
    incorrect_answers: ["Treppenhaus", "Keller", "Waschküche"],
    correct_answer: "Wohnzimmer",
  },
  {
    question: "Wo _______ Sie eigentlich in den Ferien? In Australien.",
    incorrect_answers: ["hatten", "sind", "haben"],
    correct_answer: "waren",
  },
  {
    question:
      "Du _______ doch um acht zu Hause sein. Tut mir leid, aber ich war mit einem Freund noch ein Bier trinken.",
    incorrect_answers: ["durftest", "möchtest", "konntest"],
    correct_answer: "wolltest",
  },
  {
    question:
      "_______ Sie in den letzten Ferien wieder nach Italien geflogen? Ja, wir haben dort ein kleines Ferienhaus direkt am Meer.",
    incorrect_answers: ["Haben", "Sein", "Hatten"],
    correct_answer: "Sind",
  },
  {
    question:
      "______ Berg ist der höchste in der Schweiz? Ich glaube, die Dufourspitze, die ist fast 3000 Meter hoch.",
    incorrect_answers: ["Was", "Welche", "Welches"],
    correct_answer: "Welcher",
  },
  {
    question:
      "Ich habe einen tiefen Blutdruck. Was _______ ich tun? Vielleicht _____ du die Ernährung umstellen.",
    incorrect_answers: [
      "Möchte ... möchtest",
      "Darf ... darfst",
      "Sollte ... sollst",
    ],
    correct_answer: "Soll ... solltest",
  },
  {
    question:
      "Wann kommen Sie zum Essen? _____ ich mit der Hausarbeit fertig bin.",
    incorrect_answers: ["Wann", "Als", "Dass"],
    correct_answer: "Wenn",
  },
  {
    question:
      "Warum leben Frauen eigentlich _______ als Männer? Das weiss ich auch nicht.",
    incorrect_answers: ["lang", "am längsten", "der längste"],
    correct_answer: "länger",
  },
  {
    question:
      "Probieren Sie doch mal die Hose. Ich weiss nicht. Die gefällt _______ nicht so gut.",
    incorrect_answers: ["sie", "mich", "meine"],
    correct_answer: "mir",
  },
  {
    question:
      "_______ Pullover findest du schöner, den braunen oder den blauen? Den braunen.",
    incorrect_answers: ["Was für einen", "Was für eine", "Welcher"],
    correct_answer: "Welchen",
  },
  {
    question:
      "Wer ist der Mann mit den _______ Haaren und dem _______ Gesicht? Den kenne ich leider auch nicht.",
    incorrect_answers: [
      "blonde ... schönes",
      "blondes ... schönes",
      "blondem ... schönem",
    ],
    correct_answer: "blonden ... schönen",
  },
  {
    question:
      "Du fährst oft nach Hause. Stimmt, seit ich nicht mehr bei meiner Mutter wohne, habe ich viel mehr Lust _______.",
    incorrect_answers: ["zu besuchen sie", "sie besuchen", "besuchen sie"],
    correct_answer: "sie zu besuchen",
  },
  {
    question:
      "Ja, ich würde meine Eltern auch gerne öfters besuchen, aber ich muss am Wochenende arbeiten. _______ fehlt mir einfach die Zeit dazu.",
    incorrect_answers: ["Weil", "Obwohl", "Trotzdem"],
    correct_answer: "Deshalb",
  },
  {
    question:
      "Wo _______ du gerne wohnen? Ich _______ gerne in der Stadt wohnen.",
    incorrect_answers: [
      "wolltet ... wollte",
      "wurdest ... wurde",
      "würdest ... würde",
    ],
    correct_answer: "würden ... würde",
  },
  {
    question:
      "_______ er Petra kennen lernte, heirateten sie sofort und sie bekamen drei Kinder.",
    incorrect_answers: ["Warum", "Wenn", "Wann"],
    correct_answer: "Als",
  },
  {
    question: "Bald _______ es nur noch Streit, und Petra _______ ihren Mann.",
    incorrect_answers: [
      "zu geben ... zu verlassen",
      "gegeben ... verlassen",
      "geben ... verlassen",
    ],
    correct_answer: "gab ... verliess",
  },
  {
    question:
      "Wie war das damals, als Italien Fussball-Europameister wurde? Nachdem die Italiener das Spiel _______ tagelang.",
    incorrect_answers: [
      "haben gewonnen, feierten sie",
      "hatten gewonnen, sie feierten",
      "gewonnen hatten, sie feierten",
    ],
    correct_answer: "gewonnen hatten, feierten sie",
  },
  {
    question: "Wann war Ihre letzte lange Reise? _______ meinem Studium.",
    incorrect_answers: ["Vorder", "Vorher", "Bevor"],
    correct_answer: "Vor",
  },
  {
    question:
      "Ich _______ gerne nach Luzern fahren. Das ist eine gute Idee! Da _______ wir auch das Verkehrshaus besuchen.",
    incorrect_answers: [
      "könnte ... würden",
      "würden ... könnte",
      "würde ... würden",
    ],
    correct_answer: "würde ... könnten",
  },
  {
    question:
      "Wissen Sie, _______ die Pension auch einen Swimming-Pool hat? Ich glaube schon.",
    incorrect_answers: ["dass", "wenn", "wie"],
    correct_answer: "ob",
  },
  {
    question:
      "Entschuldigen Sie bitte. Wie kommen wir zum Zoo? Da gehen Sie am besten diese Strasse _______ bis zur Kreuzung dort vorne, dann links in die Hauptstrasse und immer _______.",
    incorrect_answers: [
      "entlang ... geradeaus",
      "gegenüber ... vorbei",
      "vorbei ... gegenüber",
    ],
    correct_answer: "geradeaus ... entlang",
  },
  {
    question:
      "Was liest du denn da? Ist das gut? Nein, es macht keinen Spass. Es ist ein sehr _______ Buch.",
    incorrect_answers: ["spannendes", "faszinierendes", "super"],
    correct_answer: "mühsames",
  },
  {
    question:
      "Wie geht es denn Peter und Susanna? Sind sie schon geschieden? Ja, weisst du das denn nicht? Sie haben sich schon vor einem Jahr _______.",
    incorrect_answers: ["gelassen", "geschieden", "verschieden"],
    correct_answer: "scheiden lassen",
  },
  {
    question:
      "Wie war eigentlich die _______ von Stephanie? Oh super, wir haben bis zum frühen Morgen getanzt.",
    incorrect_answers: ["Ehe", "Scheidung", "Heirat"],
    correct_answer: "Hochzeit",
  },
  {
    question: "Kommen Sie herein und _______. Was kann ich für Sie tun?",
    incorrect_answers: ["nehmen Sie Stuhl", "sitzen Sie", "setzen Sie"],
    correct_answer: "nehmen Sie Platz",
  },
  {
    question:
      "Ich würde heute gerne essen gehen. Oh ja gerne! Ich habe mal wieder Lust _______ spanisches Essen.",
    incorrect_answers: ["für", "an", "nach"],
    correct_answer: "auf",
  },
  {
    question:
      "Du musst ihr sagen, dass sie etwas ändern muss, weil euer Privatleben so einfach _______. Na ja, mal sehen.",
    incorrect_answers: ["keine Zeit hat", "zu klein ist", "verschwindet"],
    correct_answer: "zu kurz kommt",
  },
  {
    question:
      "Ich muss mich darüber _______, dass Ihr Mitarbeiter sehr unfreundlich ist. Oh, das tut mir aber Leid. Was ist denn passiert?",
    incorrect_answers: ["schwören", "sagen", "stören"],
    correct_answer: "beschweren",
  },
  {
    question:
      "Warum fährst du eigentlich nur noch mit dem Fahrrad zur Arbeit? _______ das Benzin so teuer geworden ist.",
    incorrect_answers: ["Um", "Dass", "Für"],
    correct_answer: "Weil",
  },
  {
    question:
      "Jeder sollte ein bisschen _______ die Umwelt _______ und nicht einfach nur konsumieren. Vielleicht haben Sie ja Recht.",
    incorrect_answers: [
      "um ... kümmern",
      "bei ... helfen",
      "für ... interessieren",
    ],
    correct_answer: "auf ... achten",
  },
  {
    question:
      "Wolltest du nicht Kinotickets _______? Doch. Leider gab es keine mehr.",
    incorrect_answers: ["sorgen", "umsorgen", "versorgen"],
    correct_answer: "besorgen",
  },
  {
    question:
      "Und? Was haben Sie ihr geschenkt? Oh, ich habe _______ etwas ganz Besonderes ausgedacht.",
    incorrect_answers: ["mich", "dich", "sich"],
    correct_answer: "mir",
  },
  {
    question:
      "Was denn? Das klingt ja interessant. Ich habe ihr und ihrem Mann den Sprachkurs geschenkt, _______ sie seit Jahren immer nur geredet haben.",
    incorrect_answers: ["auf dem", "mit dem", "bei dem"],
    correct_answer: "über den",
  },
  {
    question:
      "Aber sag mal Rolf, willst du denn im Urlaub immer auf Campingplätzen übernachten? Ja, warum nicht? Das ist doch ideal für einen _______, der nicht viel Geld hat.",
    incorrect_answers: ["Studenten", "Studentin", "Studentinnen"],
    correct_answer: "Student",
  },
  {
    question:
      "Was meinen Sie? _______ in zweihundert Jahren Menschen auf dem Mars leben? Vielleicht. Aber ich würde lieber auf der Erde bleiben.",
    incorrect_answers: ["Würden", "Wurden", "Wird"],
    correct_answer: "Werden",
  },
  {
    question:
      "Akupunktur gegen Migräne? Wie funktioniert das denn? Bei der Akupunktur _______ Sie mit Nadeln _______.",
    incorrect_answers: [
      "werden ... behandelt",
      "wird ... behandeln",
      "werden ... behandeln",
    ],
    correct_answer: "wird ... behandelt",
  },
  {
    question:
      "Herr Körner, haben Sie die Stereoanlage schon ausgepackt? Nein, die _______ noch _______.",
    incorrect_answers: [
      "wird ... müssen auspacken",
      "muss ... auspacken werden",
      "wird ... ausgepackt müssen",
    ],
    correct_answer: "muss ... ausgepackt werden",
  },
  {
    question:
      "Warum bist du nach Frankreich gegangen? Meine Eltern haben mich zur Ausbildung nach Frankreich geschickt, _______ ich später bessere Berufschancen habe.",
    incorrect_answers: ["um", "dazu", "denn"],
    correct_answer: "damit",
  },
  {
    question:
      "Kennst du die Sprachschule Schneider? Natürlich! Ich bin zwei mal pro Woche dort _______ Deutsch zu lernen.",
    incorrect_answers: ["für", "wegen", "damit"],
    correct_answer: "um",
  },
  {
    question:
      "Und? Was möchtest du mal werden? Eigentlich _______ ich am liebsten Sänger werden.",
    incorrect_answers: ["hätte", "wurde", "wäre"],
    correct_answer: "würde",
  },
  {
    question:
      "Das wäre ja auch toll! Ja, nur mein Vater und meine Mutter _______ darüber nicht so glücklich.",
    incorrect_answers: ["wären", "hätten", "seien"],
    correct_answer: "würden",
  },
  {
    question:
      "Nicole ist nach der Arbeit manchmal ______ müde, _______ sie sofort einschläft.",
    incorrect_answers: ["um ... so", "sehr ... dass", "zu ... so"],
    correct_answer: "so ... dass",
  },
  {
    question:
      "Leo hat einen sehr anstrengenden Beruf: der Nachtdienst und die Probleme _______ Kranken.",
    incorrect_answers: ["der", "dem", "die"],
    correct_answer: "den",
  },
  {
    question:
      "Er raucht aber auch viel, fast zwei Schachteln pro Tag. Zwei Schachteln pro Tag? Da braucht er sich nicht _______, wenn er krank wird.",
    incorrect_answers: ["wundert", "gewundert", "wunderte"],
    correct_answer: "zu wundern",
  },
  {
    question:
      "_______ regst du dich denn so auf? _______, dass du nie den Tisch abräumst!",
    incorrect_answers: [
      "Darüber ... Über",
      "Worauf ... Darauf",
      "Darauf ... Auf",
    ],
    correct_answer: "Worüber ... Darüber",
  },
  {
    question:
      "Du hast wohl auch viel zu tun? Oh ja, und ständig kommt der Abteilungsleiter mit _______ Zusatzarbeit an.",
    incorrect_answers: ["irgendetwas", "irgendwie", "irgendeine"],
    correct_answer: "irgendwelcher",
  },
  {
    question:
      "Ich glaube, deine Chefin sollte etwas netter sein. Ja, aber das Verhalten _______ Kollegen ist auch nicht sehr freundlich.",
    incorrect_answers: ["meine liebe", "meinen lieber", "meinen lieben"],
    correct_answer: "meiner lieben",
  },
  {
    question:
      "Das beginnt doch schon beim Einkauf. _______ der vielen Aludosen und Plastikflaschen können wir doch auch Flaschen und Gläser mit Depot kaufen.",
    incorrect_answers: ["Für", "Gegen", "Ohne"],
    correct_answer: "Statt",
  },
  {
    question:
      "Papa, warum dürfen wir uns den Film nicht anschauen? Weil der erst ab 16 Jahren _______.",
    incorrect_answers: ["erlaubt werden", "erlaubt darf", "erlauben darf"],
    correct_answer: "erlaubt ist",
  },
  {
    question:
      "Sag mal, warum bist du denn in letzter Zeit immer so müde? Ach weisst du, _______ ich wieder Single bin, gehe ich abends oft tanzen und dann komme ich nicht vor Mitternacht ins Bett!",
    incorrect_answers: ["bis", "während", "bevor"],
    correct_answer: "seit",
  },
  {
    question:
      "Was würdest du machen, wenn du im Lotto _______? Ich? Ich würde eine Weltreise machen.",
    incorrect_answers: [
      "würdest gewinnen",
      "gewinnen werdest",
      "werdest gewinnen",
    ],
    correct_answer: "gewinnen würdest",
  },
  {
    question:
      "Rosa und Tomas gehen heute Abend ins Kino und ich _______ ihre beiden Kinder.",
    incorrect_answers: ["bewache", "kontrolliere", "schaue"],
    correct_answer: "hüte",
  },
  {
    question:
      "Haben Sie mit Frau Müller schon darüber gesprochen? Nein, ich habe das Thema noch nicht _______.",
    incorrect_answers: ["zugeschnitten", "zerschnitten", "geschnitten"],
    correct_answer: "angeschnitten",
  },
  {
    question:
      "Die Nachbarn haben sich gestern über die zu laute Musik beschwert. Jetzt ist die Situation total _______.",
    incorrect_answers: ["gefahren", "angefahren", "überfahren"],
    correct_answer: "verfahren",
  },
  {
    question:
      "Wie findest du die neue Freundin von Hans? Nicht besonders nett. Hans tanzt dauernd nach ihrer _______.",
    incorrect_answers: ["Anweisung", "Melodie", "Idee"],
    correct_answer: "Pfeife",
  },
  {
    question:
      "Fabian hat auf der Autobahn die Tempolimite _______. Die Polizei hat ihm sofort den Führerausweis _______.",
    incorrect_answers: [
      "beschritten ... bezogen",
      "durchschritten ... weggezogen",
      "unterschritten ... abgezogen",
    ],
    correct_answer: "überschritten ... entzogen",
  },
  {
    question:
      "Wir müssen uns beeilen. Die Theateraufführung beginnt in 5 Minuten. Ja, es ist _______ Zeit, sonst werden wir nicht mehr in die Vorstellung gelassen.",
    incorrect_answers: ["hohe", "höchste", "hoche"],
    correct_answer: "höchst",
  },
  {
    question:
      "Die _______ verwendeten Wörter in der deutschen Sprache sind «die», «und», «in», «zu» und «den».",
    incorrect_answers: ["meiste", "meistens", "Meister"],
    correct_answer: "am meisten",
  },
  {
    question:
      "Vielen Dank! _______ Ihrer Unterstützung habe ich die Prüfung mit einem «sehr gut» bestanden!",
    incorrect_answers: ["Trotz", "Anstatt", "Wegen"],
    correct_answer: "Dank",
  },
  {
    question: "Im Baumarkt gibt es alles, was ein _______ braucht.",
    incorrect_answers: ["Handarbeiter", "Bauer", "Waldarbeiter"],
    correct_answer: "Handwerker",
  },
  {
    question: "Eine reife Banane ist _______ gelb.",
    incorrect_answers: ["draussen", "ausserhalb", "aussen"],
    correct_answer: "ausser",
  },
  {
    question:
      "Gestern hatten wir _______ Besuch. Ach ja? Wer hat euch denn besucht? _______ Freunde.",
    incorrect_answers: [
      "unerwartete ... Alten",
      "unerwarteter ... Alten",
      "unerwartetes ... Alte",
    ],
    correct_answer: "unerwarteten ... Alte",
  },
  {
    question:
      "Wie ist die neue Arbeitskollegin? Sie ist noch unerfahren _______ Umgang mit dem neuen Betriebssystem.",
    incorrect_answers: ["zum", "am", "in"],
    correct_answer: "im",
  },
  {
    question:
      "In Zürich ist gestern ein Haus abgebrannt. Hätte man die Feuerwehr rechtzeitig benachrichtigt, _______ das Haus _______.",
    incorrect_answers: [
      "wäre ... gerettet werden",
      "hätte ... gerettet worden",
      "hätte ... gerettet werden",
    ],
    correct_answer: "wäre ... gerettet worden",
  },
  {
    question:
      "Karl hat die Prüfung nicht bestanden. Ach ja? Er tut aber so, als ob er die Prüfung _______.",
    incorrect_answers: ["hatte bestanden", "bestehen hatte", "hätte bestehen"],
    correct_answer: "bestanden hätte",
  },
  {
    question:
      "Gefällt Ihnen die neue Arbeit? Nein, sie ist langweilig! Wie schade! _______ langweiliger der Job ist, _______ langsamer vergeht die Zeit.",
    incorrect_answers: ["Je … je", "Desto ... je", "Je ... so"],
    correct_answer: "Je … desto",
  },
  {
    question:
      "Ärgerst du dich über die Mieterhöhung? Nein, ich ärgere _______.",
    incorrect_answers: [
      "mich darüber nicht",
      "nicht darüber mich",
      "nicht mich darüber",
    ],
    correct_answer: "mich nicht darüber",
  },
  {
    question:
      "Das ist ein sparsames Auto. Der Spareffekt kann am Benzinverbrauch _______.",
    incorrect_answers: [
      "werden gemessen",
      "gemessen worden",
      "worden gemessen",
    ],
    correct_answer: "gemessen werden",
  },
  {
    question:
      "Der durchschnittliche Deutschsprecher verfügt über circa 12 000 bis 16 000 Wörter; 3000 bis 4000 _______ sind Fremdwörter.",
    incorrect_answers: ["damit", "daran", "dazu"],
    correct_answer: "davon",
  },
  {
    question:
      "Der VW-Käfer ist sehr bekannt und viele Leute wissen auch, dass dieses Modell von Porsche _______.",
    incorrect_answers: [
      "entwickelt ist worden",
      "worden entwickelt ist",
      "ist entwickelt worden",
    ],
    correct_answer: "entwickelt worden ist",
  },
  {
    question: "Ist das die Frau, mit _______ Sie gestern gesprochen haben?",
    incorrect_answers: ["wer", "der", "die"],
    correct_answer: "wem",
  },
  {
    question: "Frau Meier ist so geizig – dabei _______ sie doch im Geld!",
    incorrect_answers: ["sitzt", "taucht", "liegt"],
    correct_answer: "schwimmt",
  },
  {
    question:
      "So habe ich das nie gesagt! Du drehst mir immer das Wort im Munde _______!",
    incorrect_answers: ["zu", "auf", "ab"],
    correct_answer: "herum",
  },
  {
    question:
      "Ein Sprecher der Polizei hat heute auf einer Konferenz zum Ausdruck _______, dass Verbrecher immer öfter unfachmännisch vorgehen.",
    incorrect_answers: ["gegeben", "gemacht", "erklärt"],
    correct_answer: "gebracht",
  },
  {
    question:
      "Peter und Susanne passen gut zusammen. Sie sind ein _______ und eine Seele.",
    incorrect_answers: ["Gehirn", "Körper", "Bauch"],
    correct_answer: "Herz",
  },
  {
    question: "Daniela bereut den _______ ihres Studiums.",
    incorrect_answers: ["Zusammenbruch", "Aufbruch", "Wegbruch"],
    correct_answer: "Abbruch",
  },
  {
    question: "Nach dem Streit hat der Millionär seinen Sohn einfach _______.",
    incorrect_answers: ["vererbt", "geerbt", "beerbt"],
    correct_answer: "enterbt",
  },
  {
    question:
      "Er war wirklich erleichtert und wirkte wie von einer Last _______.",
    incorrect_answers: ["frei", "abgenommen", "erlöst"],
    correct_answer: "befreit",
  },
  {
    question:
      "Der Neuen Zürcher Zeitung _______ nimmt die Anzahl der alten Menschen in der Schweiz zu.",
    incorrect_answers: ["entsprechend", "entlang", "gemäss"],
    correct_answer: "laut",
  },
  {
    question:
      "Jetzt sprechen wir fast eine Stunde über deinen neuen Freund und ich weiss seinen Namen gar nicht. Wie heisst er _______?",
    incorrect_answers: ["doch", "schon", "sowieso"],
    correct_answer: "eigentlich",
  },
  {
    question: "Seine Freunde beschreiben ihn als seltsam _______ Menschen.",
    incorrect_answers: ["kleidsamen", "kleidhaften", "kleidenden"],
    correct_answer: "gekleideten",
  },
  {
    question:
      "Die Nachrichten berichten, dass die Verletzten sofort ins Krankenhaus _______.",
    incorrect_answers: [
      "eingeliefert seien worden",
      "eingeliefert worden seien",
      "seien worden eingeliefert",
    ],
    correct_answer: "seien eingeliefert worden",
  },
  {
    question:
      "Der Preis des Hauses ist _______ hoch, _______ Familie Niederer es kaufen könnte.",
    incorrect_answers: ["zu ... so dass", "so ... als dass", "so ... um"],
    correct_answer: "zu ... als dass",
  },
  {
    question:
      "Sagen Sie mal, wo _______ eigentlich Ihr Auto? Ich hatte es in die Garage _______.",
    incorrect_answers: [
      "stand ... gestanden",
      "stellte ... gestellt",
      "stellte ... gestanden",
    ],
    correct_answer: "stand ... gestellt",
  },
  {
    question:
      "Leichtsinn und mangelnde Vorbereitung _______ der Grund gewesen sein, warum vier Jugendliche am Matterhorn verunglückt sind.",
    incorrect_answers: ["würden", "hätten", "dürften"],
    correct_answer: "wären",
  },
  {
    question: "Du wirst es _______ eines Beispiels besser verstehen.",
    incorrect_answers: ["angesichts", "trotz", "infolge"],
    correct_answer: "anhand",
  },
  {
    question:
      "Der Künstler bat das Modell, von dem er _______, sich in Pose zu setzen.",
    incorrect_answers: [
      "wollte eine Skizze machen",
      "machen wollte eine Skizze",
      "wollte machen eine Skizze",
    ],
    correct_answer: "eine Skizze machen wollte",
  },
  {
    question: "Frauen legen immer mehr Wert _______, viel zu verdienen.",
    incorrect_answers: ["darüber", "darunter", "daran"],
    correct_answer: "darauf",
  },
  {
    question: "Der Arzt irrte sich _______ der Diagnose.",
    incorrect_answers: ["an", "wegen", "unter"],
    correct_answer: "in",
  },
  {
    question:
      "Diese Frau kommt mir bekannt vor. Ich _______ sie schon einmal gesehen haben.",
    incorrect_answers: ["kann", "soll", "sollte"],
    correct_answer: "muss",
  },
  {
    question: "_______ du am Samstag ins Kino mitkommen?",
    incorrect_answers: ["Wärst", "Würdest", "Warst"],
    correct_answer: "Wurdest",
  },
  {
    question:
      "Das ist eine Erinnerung, die mich geprägt hat. Ja, das ist bestimmt eine _______ Erinnerung.",
    incorrect_answers: ["geprägte", "prägliche", "präghafte"],
    correct_answer: "prägende",
  },
  {
    question:
      "Wollen wir schon ins Restaurant gehen? Nein, es ist noch zu früh. Du kannst _______ noch etwas warten.",
    incorrect_answers: ["mal", "aber", "höchstens"],
    correct_answer: "ruhig",
  },
  {
    question:
      "Eigentlich wollte Lisa bei diesem Anlass überhaupt nicht mitmachen. Schliesslich machte sie dann doch _______ zum bösen Spiel.",
    incorrect_answers: [
      "fröhliches Gesicht",
      "schlechtes Antlitz",
      "schlimme Grimasse",
    ],
    correct_answer: "gute Miene",
  },
  {
    question:
      "Die Opposition hat an den Massnahmen der Regierung Kritik _______.",
    incorrect_answers: ["versucht", "hinterlassen", "probiert"],
    correct_answer: "geübt",
  },
  {
    question: "Andere Länder – _______!",
    incorrect_answers: [
      "andere Leute",
      "andere Traditionen",
      "andere Menschen",
    ],
    correct_answer: "andere Sitten",
  },
  {
    question:
      "Diese neuen Lokomotiven haben ein _______ Sicherheitssystem, um Unfälle zu verhindern.",
    incorrect_answers: ["ausgeklugtes", "ausgekugeltes", "altkluges"],
    correct_answer: "ausgeklügeltes",
  },
  {
    question: "Das ist kein Fortschritt, sondern ein _______.",
    incorrect_answers: ["Wegschritt", "Zurückschritt", "Rückwärtsschritt"],
    correct_answer: "Rückschritt",
  },
  {
    question: "Meiner Meinung nach ist das eine ernst zu _______ Kritik.",
    incorrect_answers: ["verstehende", "sehende", "werdende"],
    correct_answer: "nehmende",
  },
  {
    question: "Er will nicht _______, dass er einen Fehler gemacht hat.",
    incorrect_answers: ["zusehen", "zuschauen", "einschauen"],
    correct_answer: "einsehen",
  },
  {
    question:
      "_______ ausreichender finanzieller Unterstützung wurde das Projekt eingestellt.",
    incorrect_answers: ["Wegen", "Zwecks", "Laut"],
    correct_answer: "Mangels",
  },
  {
    question: "Die Täter _______ die Polizeisperre _______.",
    incorrect_answers: [
      "haben ... durchgebrochen",
      "sind ... durchgebrochen",
      "sind ... durchbrochen",
    ],
    correct_answer: "haben ... durchbrochen",
  },
  {
    question:
      "Weist er auch auf die Untersuchung hin, die letztes Jahr vorgenommen worden ist? Ja, er weist auf die letztes Jahr _______ Untersuchung hin.",
    incorrect_answers: [
      "vorzunehmende",
      "vorgenommene wordene",
      "vorgenommen seiende",
    ],
    correct_answer: "vorgenommene",
  },
  {
    question:
      "Ich war die ganze letzte Woche krank im Bett. Wirklich? Du _______ einen Arzt _______.",
    incorrect_answers: [
      "hättest ... sollen konsultieren",
      "solltest ... konsultiert haben",
      "hättest ... konsultiert haben sollen",
    ],
    correct_answer: "hättest ... konsultieren sollen",
  },
  {
    question: "Eigentlich gibt es nichts, _______ ich wirklich Angst habe.",
    incorrect_answers: ["worüber", "davor", "vor"],
    correct_answer: "wovor",
  },
  {
    question: "Ich freue mich ja so, die Karten fürs Theater noch _______.",
    incorrect_answers: [
      "bekommen haben",
      "zu bekommen haben",
      "haben zu bekommen",
    ],
    correct_answer: "bekommen zu haben",
  },
  {
    question:
      "Wer ist der Herr da? Das ist Herr König, _______ Firma ich einmal gearbeitet habe.",
    incorrect_answers: ["in seiner", "die", "in der"],
    correct_answer: "in dessen",
  },
  {
    question: "Ist Herr Schwarz schon gekommen? Ich habe ihn nicht _______.",
    incorrect_answers: ["gekommen sehen", "kommen gesehen", "gekommen gesehen"],
    correct_answer: "kommen sehen",
  },
  {
    question: "Wir _______ uns freuen, Sie bei uns als Gast _______.",
    incorrect_answers: [
      "würden ... dürfen zu begrüssen",
      "werden ... begrüssen zu dürfen",
      "werden ... dürfen zu begrüssen",
    ],
    correct_answer: "würden ... begrüssen zu dürfen",
  },
  {
    question: "Es regnete in Strömen – _______ wurde das Spiel fortgesetzt.",
    incorrect_answers: [
      "desto ungeachtet",
      "nichts ungeachtet",
      "trotz ungeachtet",
    ],
    correct_answer: "dessen ungeachtet",
  },
  {
    question: "Dieser Test hätte von einem Roboter viel schneller _______.",
    incorrect_answers: [
      "können ausgefüllt werden",
      "werden ausgefüllt können",
      "ausgefüllt können werden",
    ],
    correct_answer: "ausgefüllt werden können",
  },
];
